import { PostDocumentUploadResponse } from '@iwoca/lapi-client/edge';
import { useFileUploadReducer } from '../UploadedFiles/useFileUploadReducer';
import { useGetDocuments } from '../../../../../api/lendingAPI/lapiHooks';
import UploadedFiles from '../UploadedFiles/UploadedFiles';
import UploadButton from '../UploadButton/UploadButton';
import styles from './DocumentRequirement.module.css';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import classNames from 'classnames';
import { useEffect } from 'react';
import { TDocuments, TStatus } from '../NewDocUploads.types';
import Required from './Required';
import Completed from './Completed';

type TDocumentRequirement = {
    children: React.ReactNode;
    className?: string;
    documentType: PostDocumentUploadResponse['data']['document_type'];
    title?: React.ReactNode;
    status?: TStatus;
    showStatus?: boolean;
};

const DocumentRequirement = ({
    children,
    className,
    documentType,
    title,
    status,
    showStatus
}: TDocumentRequirement) => {
    const stateKey = useStateKey();
    const { data: documentsData } = useGetDocuments(stateKey);

    const {
        setFileSuccess,
        uploadedFiles,
        setAllFiles,
        setFileLoading,
        setFileError,
        setFileReject,
        removeFile
    } = useFileUploadReducer();

    useEffect(() => {
        if (documentsData) {
            const documentsForThisDocumentType = documentsData.data.filter(
                (document: TDocuments) =>
                    document.attributes!.document_type === documentType
            );

            setAllFiles(documentsForThisDocumentType);
        }
    }, [documentType, documentsData, setAllFiles]);

    return (
        <div
            className={classNames(styles.requiredDocumentContainer, className)}
        >
            {title && (
                <div className={styles.title}>
                    <h3>{title}</h3>
                    {showStatus &&
                        (status === 'required' || status === 'error') && (
                            <Required />
                        )}
                    {(status === 'pending' || status === 'completed') && (
                        <Completed />
                    )}
                </div>
            )}
            <div className={styles.documentRequirementInfo}>
                <div className={styles.descriptionContainer}>
                    <div className={styles.description}>{children}</div>
                    {uploadedFiles && (
                        <UploadedFiles
                            files={uploadedFiles}
                            removeFile={removeFile}
                        />
                    )}
                </div>
                <div className={styles.ctaButtonContainer}>
                    <UploadButton
                        documentType={documentType}
                        onFileSuccess={setFileSuccess}
                        onFileLoading={setFileLoading}
                        onFileError={setFileError}
                        onFileReject={setFileReject}
                    />
                </div>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DocumentRequirement;
